import { InjectionToken, Signal } from '@angular/core';

import { DataState } from '../model/data-state';

/**
 * The state `$data` and `$state` read where no component binds its own input: a node scope provides its node's for the
 * actions fired below it (D11), and `connectSchemaDataSource` hands a source the state its node was handed. A spec
 * provides it to stand in for either.
 */
export const SCHEMA_STATE = new InjectionToken<Signal<DataState | undefined>>('SCHEMA_STATE');
